<div>
  <div class="tabela__mensagens">
    <h6 class="mensagens__title">Mensagens</h6>
  </div>
  <ng-content></ng-content>
</div>
